const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const Register = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'REGISTER_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'REGISTER_ERROR':
            return { loading: false, error: true, data: action.payload };
        case 'REGISTER_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'REGISTER_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default Register